// 自动滚动时间评论
export const SCROLL_TIME = 50;
export const TEXT_SCROLL_TIME = 150;

// 用户统计颜色
export const USER_COLORS = [
    '#ffad2d',
    '#2bcced',
    '#1dcb33',
    '#a250d6',
    '#0254d7',
    '#e6106b'
];

// 方向与值的对应关系
export const DIRECTION = {
    0: '北',
    1: '东北',
    2: '东',
    3: '东南',
    4: '南',
    5: '西南',
    6: '西',
    7: '西北'
};

export const CODE = 'gedibim';
